import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getValueByLanguage, showNotificationDialog } from '../../../utils';
import Header from '../../../components/header/Header';
import useR05Api from '../../../api/useR05Api';
import { APP_ID, TIMEOUT_DURATION } from '../../../utils/Constants';
import BuyTicketItem from '../../../components/BuyTicketItem/BuyTicketItem';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import styles from './styles.module.css';

const BuyGroupTicketScreen = () => {
    const [loading, setLoading] = useState(false);
    const [ticketList, setTicketList] = useState([]);
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const { fetchTicketsByGroup } = useR05Api();
    const { group } = location.state || {};
    const l = useCallback(
        (text) => {
            return getValueByLanguage(text, i18n.language);
        },
        [i18n.language],
    );

    //チケット一覧の情報を取得する
    useEffect(() => {
        if (!navigator.onLine) {
            showNotificationDialog(
                'error',
                '',
                t('notification.title'),
                'サーバーとの通信に失敗しました。通信状態の良いところで再度お試しください。',
            );
            return;
        }

        (async () => {
            let timeoutId;

            try {
                timeoutId = setTimeout(() => {
                    setLoading(false);
                    showNotificationDialog('error', '', t('notification.title'), 'チケット一覧の取得に失敗しました');
                }, TIMEOUT_DURATION);

                setLoading(true);
                const ticketList = await fetchTicketsByGroup({ appId: APP_ID, ...group });
                clearTimeout(timeoutId);
                setLoading(false);
                setTicketList(ticketList);
            } catch (error) {
                setLoading(false);
                clearTimeout(timeoutId);
            }
        })();
    }, [group, t, fetchTicketsByGroup]);

    return (
        <>
            {loading && <CenterLoading />}
            <Header title={t('header.buy-ticket')} />
            <div className={`content-container scrollable`}>
                {group && (
                    <div className={styles.wrapper}>
                        <p className={styles.groupName}>{l(group.groupName)}</p>
                        <div className={styles.groupSubtitle}>{l(group.groupSubtitle)}</div>
                        <div className={styles.groupTicketList}>
                            {ticketList.map((ticket, index) => (
                                <BuyTicketItem key={index} ticket={ticket} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default BuyGroupTicketScreen;
